import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import { ClickIt, RichHtmlAlertTitle } from "../../../Constants/Constants";
import { RichHtmlAlertSubTitle } from "../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const RichHtmlAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "<strong>HTML <u>example</u></strong>",
      icon: "info",
      html: `
              You can use <b>bold text</b>,
              <a href="#" autofocus>links</a>,
              and other HTML tags
            `,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: `
              <i class="fa fa-thumbs-up"></i> Great!
            `,
      confirmButtonAriaLabel: "Thumbs up, great!",
      cancelButtonText: `
              <i class="fa fa-thumbs-down"></i>
            `,
      cancelButtonAriaLabel: "Thumbs down",
    });
  };
  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={RichHtmlAlertTitle} span={RichHtmlAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="warning" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RichHtmlAlert;
